import {useEffect, useState, useRef} from "react";

export const useDrag = () => {
    const [offsetX, setOffsetX] = useState(0);
    const [offsetY, setOffsetY] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const startDragRef = useRef({ x: 0, y: 0 });

      const handleMouseDown = (e: React.MouseEvent | React.TouchEvent) => {
        const isTouch = "touches" in e;

        const clientX = isTouch ? e.touches[0].clientX : (e as React.MouseEvent).clientX;
        const clientY = isTouch ? e.touches[0].clientY : (e as React.MouseEvent).clientY;

        if (!isTouch && (e as React.MouseEvent).button !== 0) return;

        if (isTouch) e.nativeEvent.preventDefault();
        else e.preventDefault();

        setIsDragging(true);
        startDragRef.current = {
            x: clientX,
            y: clientY 
        };
    };

     useEffect(() => {
            if (!isDragging) return;
    
            const handleMouseMove = (e: MouseEvent | TouchEvent) => {
                const isTouch = "touches" in e && e.touches.length > 0;

                const clientX = isTouch ? e.touches[0].clientX : (e as MouseEvent).clientX;
                const clientY = isTouch ? e.touches[0].clientY : (e as MouseEvent).clientY;

                const dx = clientX - startDragRef.current.x;
                const dy = clientY - startDragRef.current.y;
    
            setOffsetX(prev => prev + dx);
            setOffsetY(prev => prev + dy);

            startDragRef.current = { x: clientX, y: clientY };
     };
    
            const handleMouseUp = () => setIsDragging(false);
    
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);

            document.addEventListener("touchmove", handleMouseMove, { passive: false });
            document.addEventListener("touchend", handleMouseUp);
    
            return () => {
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);

                document.removeEventListener("touchmove", handleMouseMove);
                document.removeEventListener("touchend", handleMouseUp);
            };
        }, [isDragging]);

        return{
            offsetX,
            offsetY,
            isDragging,
            setIsDragging,
            startDragRef,
            handleMouseDown,
            setOffsetX,
            setOffsetY
        }

};